
import { getLikedPromptsByUserId, getRecentlyUsedPromptsByUserId } from "@/utils/promptUtils";
import { Prompt } from "./promptTypes";

/**
 * Fetches prompts liked by a specific user
 */
export const getLikedPrompts = async (userId: string): Promise<Prompt[]> => {
  return getLikedPromptsByUserId(userId);
};

/**
 * Fetches prompts recently used by a specific user
 */
export const getRecentlyUsedPrompts = async (userId: string): Promise<Prompt[]> => {
  return getRecentlyUsedPromptsByUserId(userId);
};
